module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel01_1280_1280_ja-def375ae26b588d7eab12fa8b597f3ee.jpg";